import React from "react";
import styled from "styled-components";
import { cloneDeep } from 'lodash';

import FetchModule from "../../../Model/Share/Network/FetchModule";
import { useLanguage } from '../../../Context/LanguageContext';
import { useTheme } from '../../../Context/ThemeContext';
import { lightTheme, darkTheme } from '../../../Styles/theme';

import { ReactComponent as EditSvg } from '../../../image/Edit.svg';


export default function RegistrationSettingMessageBox(props) {
  const {
    isActivate,
    registration,
    setRegistration,
    onClickEdit,
  } = props;

  const { t } = useLanguage();

  const { isDark } = useTheme();
  const theme = isDark ? darkTheme : lightTheme;

  // 체크박스 클릭시 //
  function onClickCheckBox(division) {
    if (!isActivate) return;

    let newData = cloneDeep(registration);
    
    // 신규 등록시 //
    if (division === 'NewRegistration') {
      newData.newRegistration.isUseSetting = !newData.newRegistration.isUseSetting;

      saveMessageSetting(newData.newRegistration);
    }
    // 재등록시 //
    else {
      newData.reRegistration.isUseSetting = !newData.reRegistration.isUseSetting;

      saveMessageSetting(newData.reRegistration);
    }

  }

  // 변수 → 칩 렌더링 //
  function renderText(value) {
    const variableMap = {
      '{store_name}': t('messageSend.variable.storeName'),
      '{user_name}': t('messageSend.variable.userName'),
      '{membership_name}': t('messageSend.variable.membershipName'),
      '{exercise_period}': t('messageSend.variable.exercisePeriod'),
      '{locker_name}': t('messageSend.variable.lockerName'),
      '{coach_name}': t('messageSend.variable.coachName'),
      '{class_name}': t('messageSend.variable.className'),
      '{reserve_time}': t('messageSend.variable.reserveTime'),
      '{class_time}': t('messageSend.variable.classTime'),
      '{holding_start_date}': t('messageSend.variable.holdingStartDate'),
      '{holding_end_date}': t('messageSend.variable.holdingEndDate'),
    };
    return value.split('\n').map((line, lineIdx) => (
      <MessageLine key={lineIdx}>
        {line.split(/(\{[^}]+\})/g).map((part, i) => {
          const label = variableMap[part];
          if (label) return <VariableChip key={i}>{label.replace(/^\{|\}$/g, '')}</VariableChip>;
          return part ? <span key={i}>{part}</span> : null;
        })}
      </MessageLine>
    ));
  }

  // 데이터 저장 //
  function saveMessageSetting(data) {
    let requestData = {
      id: data.id,
      storeId: data.storeId,
      division: data.division,
      text: data.text,
      title: data.title,
      applyDay: data.applyDay,
      applyTime: data.applyTime,
      isUseSetting: data.isUseSetting
    }

    const fetchModule = new FetchModule();
    (
      async () => {
        const responseData = await fetchModule.postDataVersion2('message_setting/save', 'POST', requestData);

        if (responseData.status === 200) {
          let newData = cloneDeep(registration);

          // 회원 신규 등록시 //
          if (data.division === 'NewRegistration') newData.newRegistration = responseData.data;
          // 회원권 연장 및 재 등록시 //
          else if (data.division === 'ReRegistration') newData.reRegistration = responseData.data;

          setRegistration(newData);
        }
      }
    )();
  }

  return (
    <TopLevelWrapper>
      <DivisionBox>
        <Text fontFamily='NotoSansKR-Bold' fontSize={16} color={theme.primary}>{t('messageSend.autoMessage.registration')}</Text>
        <Text fontFamily='NotoSansKR-Medium' fontSize={14} color={theme.subText}>{t('messageSend.editModal.descRegistrationSetting')}</Text>
      </DivisionBox>
      <SettingBox>
        <SettingColumnBox>
          <SlideComponentWrapper onClick={() => onClickCheckBox('NewRegistration')}>
            <SlideOutBox isClicked={registration.newRegistration.isUseSetting && isActivate}>
              <SlideInBox isClicked={registration.newRegistration.isUseSetting && isActivate} />
            </SlideOutBox>
            <SettingOptionTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text} hover='pointer'>{t('messageSend.editModal.descNewRegistration')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={12} color={theme.subText} hover='pointer'>{t('messageSend.editModal.descImmediatelyAfterRegistration')}</Text>
            </SettingOptionTextWrapper>
          </SlideComponentWrapper>
          <SettingTextWrapper>
            <TextWrapper>
              <MessageText>{renderText(registration.newRegistration.text)}</MessageText>
              <CharCountText>{`SMS ${registration.newRegistration.text.length}${t('messageSend.editModal.smsCharCountSuffix')}`}</CharCountText>
            </TextWrapper>
          </SettingTextWrapper>
          <ModifyButton onClick={() => onClickEdit(registration.newRegistration)}>
            <EditIcon />
          </ModifyButton>
        </SettingColumnBox>

        <DivisionLine/>

        <SettingColumnBox>
          <SlideComponentWrapper onClick={() => onClickCheckBox('ReRegistration')}>
            <SlideOutBox isClicked={registration.reRegistration.isUseSetting && isActivate}>
              <SlideInBox isClicked={registration.reRegistration.isUseSetting && isActivate} />
            </SlideOutBox>
            <SettingOptionTextWrapper>
              <Text fontFamily='NotoSansKR-Regular' fontSize={16} color={theme.text} hover='pointer'>{t('messageSend.editModal.descReRegistration')}</Text>
              <Text fontFamily='NotoSansKR-Regular' fontSize={14} color={theme.subText} hover='pointer'>{t('messageSend.editModal.descImmediatelyAfterPayment')}</Text>
            </SettingOptionTextWrapper>
          </SlideComponentWrapper>
          <SettingTextWrapper>
            <TextWrapper>
              <MessageText>{renderText(registration.reRegistration.text)}</MessageText>
              <CharCountText>{`SMS ${registration.reRegistration.text.length}${t('messageSend.editModal.smsCharCountSuffix')}`}</CharCountText>
            </TextWrapper>
          </SettingTextWrapper>
          <ModifyButton onClick={() => onClickEdit(registration.reRegistration)}>
            <EditIcon />
          </ModifyButton>
        </SettingColumnBox>
      </SettingBox>
    </TopLevelWrapper>
  )
}

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: flex-start;
  align-items: flex-start;

  width: 100%;

  gap: 10px;
`;

const DivisionBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  height: 53px;

  gap: 6px;
`;

const SettingBox = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  padding: 10px 20px;

  box-sizing: border-box;
  width: 100%;
  
  border-radius: 10px;

  background-color: ${props => props.theme.subBackground};
`;

const SettingColumnBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100%;
  min-height: 40px;
`;

const SlideComponentWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  width: 370px;
  height: 100%;

  gap: 30px;

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const SlideOutBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;

  flex-shrink: 0;
  box-sizing: border-box;
  width: 70px;
  height: 32px;

  border: ${props => props.isClicked ? `1px solid ${props.theme.primary}` : `1px solid ${props.theme.line}`};
  border-radius: 9px;
  background-color: ${props => props.isClicked ? props.theme.primary : props.theme.subBackground};

  transition: all 0.3s ease-in-out;
`;

const SlideInBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  margin-left: ${props => props.isClicked ? '43px' : '4px'};

  width: 22px;
  height: 22px;

  border-radius: 7px;
  background-color: ${props => props.isClicked ? props.theme.white : props.theme.line};

  transition: all 0.3s ease-in-out;
`;

const SettingTextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  
  justify-content: center;
  align-items: center;

  width: 566px;
  height: 100%;

  border-left: 1px solid ${props => props.theme.line};
`;

const SettingOptionTextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  width: 100%;

  gap: 3px;
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-start;

  padding: 10px 15px;

  gap: 5px;

  box-sizing: border-box;
  width: 100%;
`;

const MessageText = styled.div`
  display: block;
`;

const MessageLine = styled.div`
  display: block;

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  line-height: 21px;
  color: ${props => props.theme.text};

  &:not(:last-child) {
    margin-bottom: 5px;
  }
`;

const CharCountText = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: ${props => props.theme.subText};

  margin: 0;
`;

const VariableChip = styled.span`
  display: inline-flex;
  align-items: center;

  padding: 0 5px;
  
  height: 21px;

  border-radius: 5px;
  background-color: ${props => props.theme.primaryAlpha20};

  font-family: NotoSansKR-Regular;
  font-size: 14px;
  color: ${props => props.theme.text};

  transition: all 0.3s ease-in-out;
`;

const EditIcon = styled(EditSvg)`
  width: 18px;
  height: 18px;
  flex-shrink: 0;

  & path {
    fill: ${props => props.theme.line};
  }

  transition: all 0.3s ease-in-out;
`;

const ModifyButton = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: flex-end;

  width: 59px;
  height: 100%;

  background-color: ${props => props.theme.subBackground};

  @media (hover: hover) {
    &:hover {
      cursor: pointer;
    }
  }
`;

const DivisionLine = styled.div`
  width: calc(100% - 20px);
  height: 1px;

  margin: 15px 0px;

  background-color: ${props => props.theme.line};
`;

const Text = styled.p`
  font-family: ${props => props.fontFamily};
  font-size: ${props => props.fontSize}px;

  color: ${props => props.color};

  margin: 0 0 0 0;

  @media (hover: hover) {
    &:hover {
      cursor: ${props => props.hover};
    }
  }

  transition: all 0.3s ease-in-out;
`;